/* The product page's lower sections (product page story spec §5–9): the phone's panels, Copy link,
   In the room's "See it on your own wall" and Keep exploring. Their words come from the story section's
   data-gr-i18n="story" block, with English as the fallback. */
(() => {
  if (window.grStory) return;
  window.grStory = true;
  const ENTITIES = { '&amp;': '&', '&lt;': '<', '&gt;': '>', '&quot;': '"', '&#39;': "'", '&#x27;': "'" };
  const decode = (s) => (typeof s === 'string' ? s.replace(/&(?:amp|lt|gt|quot|#39|#x27);/g, (m) => ENTITIES[m]) : s);
  const words = (() => {
    try { return JSON.parse(document.querySelector('[data-gr-i18n="story"]')?.textContent || '{}'); } catch (e) { return {}; }
  })();
  const T = { copied: decode(words.copied) || 'Link copied' };
  const still = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* What you get starts closed on a phone; Delivery stays open, and a laptop shows both (spec §5.2) */
  if (window.matchMedia('(max-width: 749px)').matches) {
    document.querySelectorAll('[data-gr-panel="get"]').forEach((d) => { d.open = false; });
  }

  /* Copy link: the page's address to the clipboard, or shown to copy by hand where the clipboard is refused */
  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-gr-copy]');
    if (!b) return;
    const status = b.parentElement.querySelector('[data-gr-copy-status]');
    const url = b.dataset.url || window.location.href;
    const say = (text) => { if (status) status.textContent = text; };
    const write = navigator.clipboard?.writeText ? navigator.clipboard.writeText(url) : Promise.reject(new Error('no clipboard'));
    write.then(() => say(T.copied), () => say(url));
  });

  /* In the room's "See it on your own wall": the buy box's own try-on button (data-tryon-open="auto", which scrolls
     and moves focus itself), not the gallery's "On your wall" tab that comes first in the page (spec §6) */
  const opener = document.querySelector('[data-tryon-open="auto"]') || document.querySelector('[data-tryon-open]');
  document.querySelectorAll('[data-gr-band-wall]').forEach((b) => {
    b.hidden = !opener;
    b.addEventListener('click', () => {
      if (!opener) return;
      if (opener.dataset.tryonOpen !== 'auto') opener.scrollIntoView({ block: 'center', behavior: still ? 'auto' : 'smooth' });
      opener.click();
    });
  });

  /* Keep exploring (spec §9): the theme's recently viewed trail without this artwork, up to 8, from the artwork cards;
     with no trail, "More like this" from Shopify's related recommendations, or else the first four others. The cards
     come from the product's keep-cards view, fetched once when the shopper nears the section (26 Oct 2026: they used to
     be built into every product page). */
  const keep = document.querySelector('[data-gr-keep]');
  if (keep) {
    const current = String(keep.dataset.productId);
    const part = keep.querySelector('[data-gr-keep-trail]'), row = keep.querySelector('[data-gr-keep-row]');
    const heading = keep.querySelector('[data-gr-keep-heading]');
    let cardsLoad = null;
    const loadCards = () => {
      if (!cardsLoad) {
        cardsLoad = fetch(keep.dataset.cardsUrl).then((r) => (r.ok ? r.text() : Promise.reject(new Error(String(r.status)))))
          .then((html) => new Map([...new DOMParser().parseFromString(html, 'text/html').querySelectorAll('[data-gr-keep-cards] [data-id]')]
            .map((c) => [c.dataset.id, c])))
          .catch(() => new Map());
      }
      return cardsLoad;
    };
    const show = (nodes) => {
      if (!nodes.length) return;
      row.replaceChildren(...nodes.map((n) => document.importNode(n, true)));
      part.hidden = false;
      keep.hidden = false;
    };
    let trail = [];
    try { trail = JSON.parse(window.localStorage.getItem('sht-recently-viewed') || '[]'); } catch (e) { trail = []; }
    const wanted = (Array.isArray(trail) ? trail : []).map((i) => String(i && i.id))
      .filter((id, i, all) => id && id !== 'undefined' && id !== current && all.indexOf(id) === i);
    const others = () => loadCards().then((cards) => show([...cards.entries()].filter(([id]) => id !== current).slice(0, 4).map(([, c]) => c)));
    const related = () => {
      heading.textContent = heading.dataset.more || heading.textContent;
      const url = `${keep.dataset.recsUrl}?product_id=${encodeURIComponent(current)}&limit=4&intent=related`
        + `&section_id=${encodeURIComponent(keep.dataset.sectionId)}`;
      fetch(url).then((r) => (r.ok ? r.text() : Promise.reject(new Error(String(r.status))))).then((html) => {
        const got = [...new DOMParser().parseFromString(html, 'text/html').querySelectorAll('[data-gr-keep-recs] [data-id]')]
          .filter((c) => c.dataset.id !== current);
        if (got.length) show(got);
        else others();
      }).catch(others);
    };
    const fill = () => {
      if (!wanted.length) return related();
      loadCards().then((cards) => {
        const ids = wanted.filter((id) => cards.has(id)).slice(0, 8);
        if (ids.length) show(ids.map((id) => cards.get(id)));
        else related();
      });
    };
    // The section is hidden until filled when the artwork has no pair, so watch its place in the page instead
    const spot = keep.closest('.shopify-section') || (keep.hidden ? keep.parentElement : keep);
    if ('IntersectionObserver' in window) {
      const io = new IntersectionObserver((entries) => {
        if (entries.some((e) => e.isIntersecting)) { io.disconnect(); fill(); }
      }, { rootMargin: '900px 0px' });
      io.observe(spot);
    } else {
      fill();
    }
  }
})();
